export default __webpack_public_path__ + "static/og_logo_dark-28aadda723197eeb6f96111978776c68.png";